export const firmsActionTypes = {
  GET_FIRMS_SUCCESS: 'firms/GET_FIRMS_SUCCESS',
  RESET: 'firms/RESET',
};

